import React, { FC } from 'react';
import Avatar from 'react-avatar';

import Styled from './styles';

type IProps = {
	size: number;
	avatar?: string;
	name?: string;
	isBorder?: boolean;
	isShadow?: boolean;
};

const RoundImg: FC<IProps> = ({
	size,
	avatar,
	name,
	isBorder = false,
	isShadow = false,
}) => {
	return (
		<Styled.Wrapper isBorder={isBorder} isShadow={isShadow} size={size}>
			{avatar ? (
				<img
					style={{
						width: size,
						height: size,
						borderRadius: size / 2,
						objectFit: 'cover',
					}}
					src={avatar}
					alt={'avatar'}
				/>
			) : (
				<Avatar name={name} size={`${size}`} round={`${size / 2}px`} />
			)}
		</Styled.Wrapper>
	);
};

export default RoundImg;
